import React from "react";
import { OrderData } from "../types/order";
import { formatDate } from "src/shared/components/dateUtils";

interface OrderSummaryProps {
  order: OrderData;
}

interface SummaryItemProps {
  label: string;
  value: React.ReactNode;
}

const SummaryItem: React.FC<SummaryItemProps> = ({ label, value }) => (
  <div>
    <p className="font-bold text-gray-800">{label}</p>
    <p className="font-medium text-gray-600">{value}</p>
  </div>
);

const OrderSummary: React.FC<OrderSummaryProps> = ({ order }) => {
  const fields: SummaryItemProps[] = [
    { label: "Customer Name", value: order.customer?.Name || "N/A" },
    { label: "Phone Number", value: order.customer?.phone_number || "N/A" },
    { label: "Staff", value: order.staffname || "N/A" },
    { label: "Total Items", value: order.totalQuantity || "N/A" },
    {
    label: "Subtotal",
    value: `${(Number(order?.Finalamount) + Number(order?.discount || 0)).toFixed(2)} QAR`
  },
    { label: "Discount", value: `${order?.discount || 0} QAR` },
    { label: "Total Amount", value: `${order?.Finalamount || "0"} QAR` },
    { label: "Received Amount", value: `${ order?.payments[0].ReceivedAmount || "0"} QAR` },
    { label: "Remaining Amount", value: `${order?.RemainingAmount || "0"} QAR` },
    { label: "Payment Method", value: order?.payments?.[0]?.Paymentmethod || "N/A" },
    { label: "Order Date & Time", value: `${formatDate(order?.Orderdate || "")} ${order?.Ordertime || ""}` },
  ];

  return (
    <div className="p-6 rounded-lg bg-white shadow-md mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {fields.map((field, index) => (
          <SummaryItem key={index} label={field.label} value={field.value} />
        ))}
      </div>
    </div>
  );
};

export default OrderSummary;
